import { createAsyncThunk } from '@reduxjs/toolkit';

import {
  getQuoteDetailRequest,
  getQuotesRequest,
  getWeatherRequest,
} from '~/services';
import type { propsApiQuoteProduct } from '~/services/http/interfaces';

import type { Weather } from './interfaces';
import {
  detailFailure,
  detailRequest,
  detailSuccess,
  quotesFailure,
  quotesRequest,
  quotesSuccess,
  weatherFailure,
  weatherRequest,
  weatherSuccess,
} from './slices';

export const fetchQuotes = createAsyncThunk(
  'quotes/fetch',
  async (uf: string | null, { dispatch }) => {
    dispatch(quotesRequest());
    try {
      const { data } = await getQuotesRequest(uf);
      dispatch(
        quotesSuccess({
          items: data.items.map((it) => ({
            product: it.product,
            uf: it.uf,
            price: it.price,
            unit: it.unit,
            praca: it.praca,
            source: it.source,
            quotedAt: it.quotedAt,
            change: it.change,
          })),
          fetchedAt: data.updatedAt ?? new Date().toISOString(),
        }),
      );
      return true;
    } catch {
      dispatch(quotesFailure());
      return false;
    }
  },
);

export const fetchWeather = createAsyncThunk(
  'quotes/fetch-weather',
  async (
    params: { lat?: number; lon?: number; city?: string },
    { dispatch },
  ): Promise<Weather | null> => {
    dispatch(weatherRequest());
    try {
      const { data } = await getWeatherRequest(params);
      dispatch(weatherSuccess(data as Weather));
      return data as Weather;
    } catch {
      dispatch(weatherFailure());
      return null;
    }
  },
);

export const fetchQuoteDetail = createAsyncThunk(
  'quotes/fetch-detail',
  async (
    { product, uf }: { product: propsApiQuoteProduct; uf?: string | null },
    { dispatch },
  ) => {
    dispatch(detailRequest());
    try {
      const { data } = await getQuoteDetailRequest(product, uf);
      dispatch(detailSuccess(data));
      return data;
    } catch {
      dispatch(detailFailure());
      return null;
    }
  },
);
